import Canvas from './Canvas';

import { imagesLoading } from '../../../actions/ui'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export default connect(null,
    (dispatch) => ({
        actions: bindActionCreators({ imagesLoading }, dispatch)
    })
)(Canvas)